const initialState = {
    all_activity: [],
    error:"",
};

const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ALL_ACTIVITY_SUCCESS':
            return {
                ...state,
                all_activity: action.payload || [],
                error: null
            };
        case 'GET_ALL_ACTIVITY_SUCCESS':
            return {
                ...state,
                all_activity: action.payload || [],
                error: null
            };            
            case 'SET_ALL_ACTIVITY_FAILURE':
                return { ...state, error: action.payload };
            default:
                return state;
    }
};

export default activityReducer;
